import { useEffect, useMemo, useState } from 'react'
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Avatar,
  TextField,
  Button,
  Stack,
  Chip,
  Divider,
  IconButton,
  InputAdornment
} from '@mui/material'
import { motion } from 'framer-motion'
import Icon from '../../../components/icon'
import { useNavigate } from 'react-router-dom'

import mdiChat from '@iconify-icons/mdi/chat'
import mdiTag from '@iconify-icons/mdi/tag'
import mdiAccountDetails from '@iconify-icons/mdi/account-details'
import mdiCartPlus from '@iconify-icons/mdi/cart-plus'
import mdiNoteText from '@iconify-icons/mdi/note-text'
import mdiCalendarClock from '@iconify-icons/mdi/calendar-clock'
import mdiAccount from '@iconify-icons/mdi/account'

import apiUrl from '../../../configs/constant';
import { useToast } from '../../../components/ToastProvider'
import axios from 'axios'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'

import DialogCatatan from '../../../components/omni/DialogCatatan'
import DialogOrder from '../../../components/omni/DialogOrder'
import DialogRingkasan from '../../../components/omni/DialogRingkasan'
import DialogTag from '../../../components/omni/DialogTag'
import DialogActivity from '../../../components/omni/DialogActivity'

/* =======================
   DATA
======================= */
export const summaryCards = {
  all: { label: 'All Contacts', count: 128, color: '#FF9F1C', icon: 'mdi:account-multiple' },
  active: { label: 'Active Chat', count: 42, color: '#2EC4B6', icon: 'mdi:chat' },
  followup: { label: 'Need Follow Up', count: 18, color: '#F77F00', icon: 'mdi:phone-forward' },
  pending: { label: 'Pending', count: 9, color: '#5F5CE5', icon: 'mdi:clock-outline' },
  vip: { label: 'VIP Customers', count: 6, color: '#FFD700', icon: 'mdi:crown' },
  priority: { label: 'High Priority', count: 5, color: '#e84393', icon: 'mdi:alert-circle' },
  complaint: { label: 'Complaints', count: 4, color: '#E71D36', icon: 'mdi:message-alert' },
  blocked: { label: 'Blocked', count: 3, color: '#495057', icon: 'mdi:block-helper' }
} as const

const CHAT_ACTIONS = [
  { key: 'chat', label: 'Chat Customer', icon: mdiChat },
  { key: 'tag', label: 'Tag', icon: mdiTag },
  { key: 'summary', label: 'Summary', icon: mdiAccountDetails },
  { key: 'order', label: 'Order', icon: mdiCartPlus },
  { key: 'note', label: 'Catatan', icon: mdiNoteText },
  { key: 'schedule', label: 'Jadwal Aktifitas', icon: mdiCalendarClock },
] as const

export default function ContactUI() {
  const navigate = useNavigate();
  const { showToast } = useToast()

  const userData = JSON.parse(localStorage.getItem('user')!)
  const token = userData.token

  const [search, setSearch] = useState<string>('')
  const [listContact, setListContact] = useState<any[]>([]);
  const [selectedContact, setSelectedContact] = useState<any>(null)
  const [activeDialog, setActiveDialog] = useState<any>(null)

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleMenuOpen = (e: React.MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget)
  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  useEffect(() => {
    getContact()
  }, []);

  const getContact = () => {
    const url = apiUrl.apiUrl + '/omni/chat/get-contact'
    axios
      .get(url, {
        params: {},
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(response => {
        if (response.data.success) {
          const data = response.data.data
          setListContact(data)
        } else {
          showToast(response.data.message, "error");
        }
      })
  }

  const getChatByContact = (id: any) => {
    const url = apiUrl.apiUrl + '/omni/chat/get-chat-by-contact/' + id
    axios
      .get(url, {
        params: {},
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(response => {
        if (response.data.success) {
          const data = response.data.data
          setSelectedContact(data)
        } else {
          showToast(response.data.message, "error");
        }
      })
  }

  const handleClickAction = (el: any) => {
    if (el.key == 'chat') {
      navigate('/omni/chat-customer/?contact=' + selectedContact?.contact_name)
    } else {
      setActiveDialog(el.key)
    }

    handleMenuClose()
  }

  const closeDialog = () => setActiveDialog(null)

  const filteredContact = useMemo(() => {
    if (!search) return listContact

    const keyword = search.toLowerCase()

    return listContact.filter((c: any) =>
      c.contact_name?.toLowerCase().includes(keyword) ||
      c.phone?.toLowerCase().includes(keyword) ||
      c.summary_name?.toLowerCase().includes(keyword)
    )
  }, [search, listContact])

  const handleSelectContact = (contact: any) => {
    getChatByContact(contact.sdcust_id)
  }

  return (
    <Box minHeight="100vh">
      {/* SUMMARY */}
      <Grid container spacing={3} mb={3}>
        {Object.entries(summaryCards).map(([key, card]) => (
          <Grid item xs={12} md={3} key={card.label}>
            <motion.div
              whileHover={{ scale: 1.03 }}
              transition={{ duration: 0.2, ease: 'easeOut' }}
            >
              <Card
                sx={{
                  borderRadius: 3,
                  color: '#fff',
                  background: `linear-gradient(135deg, ${card.color} 0%, ${card.color}CC 100%)`,
                  border: '1px solid rgba(255,255,255,0.2)'
                }}
              >
                <CardContent>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    {/* TEXT */}
                    <Box>
                      <Typography
                        variant="caption"
                        sx={{
                          opacity: 0.85,
                          letterSpacing: 0.6
                        }}
                      >
                        {card.label.toUpperCase()}
                      </Typography>

                      <Typography
                        variant="h3"
                        fontWeight={800}
                        sx={{ lineHeight: 1.1 }}
                      >
                        {card.count}
                      </Typography>
                    </Box>

                    {/* ICON */}
                    <Box
                      sx={{
                        width: 52,
                        height: 52,
                        borderRadius: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor: 'rgba(255,255,255,0.15)'
                      }}
                    >
                      <Icon icon={card.icon} fontSize={28} />
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </motion.div>
          </Grid>
        ))}
      </Grid>

      {/* MAIN */}
      <Grid container spacing={3}>
        {/* LEFT LIST */}
        <Grid item xs={12} md={5}>
          <Card sx={{ borderRadius: 3, height: '100%' }}>
            <CardContent sx={{ pb: 2 }}>
              {/* SEARCH */}
              <TextField
                fullWidth
                size="small"
                placeholder="Cari kontak…"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Icon icon="mdi:magnify" />
                    </InputAdornment>
                  ),
                  endAdornment: search && (
                    <InputAdornment position="end">
                      <IconButton size="small" onClick={() => setSearch('')}>
                        <Icon icon="mdi:close" />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />

              <Divider sx={{ my: 2 }} />

              {/* LIST */}
              <Box
                sx={{
                  maxHeight: 'calc(5 * 82px)',
                  overflowY: 'auto',
                  pr: 1
                }}
              >
                <Stack spacing={1}>
                  {filteredContact.map((c: any) => {
                    const isActive = selectedContact?.sdcust_id === c.sdcust_id
                    const firstChar = c.contact_name?.[0]?.toUpperCase() || '?'

                    return (
                      <Box
                        key={c.sdcust_id}
                        onClick={() => handleSelectContact(c)}
                        sx={{
                          position: 'relative',
                          borderRadius: 3,
                          p: 1.5,
                          cursor: 'pointer',
                          border: '3px solid',
                          borderColor: isActive ? 'primary.main' : 'divider',
                          bgcolor: isActive ? 'primary.lighter' : 'transparent',
                          transition: 'all .2s ease',
                          '&:hover': {
                            bgcolor: isActive
                              ? 'primary.lighter'
                              : 'action.hover'
                          }
                        }}
                      >
                        <Stack direction="row" spacing={2} alignItems="center">
                          <Avatar
                            sx={{
                              width: 44,
                              height: 44,
                              fontWeight: 700,
                              bgcolor: isActive
                                ? 'primary.main'
                                : 'grey.300',
                              color: isActive ? '#fff' : 'text.primary'
                            }}
                          >
                            {firstChar}
                          </Avatar>

                          <Box flexGrow={1} minWidth={0}>
                            <Typography fontWeight={600} noWrap>
                              {c.contact_name}
                            </Typography>

                            <Typography
                              variant="body2"
                              color="text.secondary"
                              noWrap
                            >
                              {c.phone}
                            </Typography>

                            {c.summary_name && (
                              <Chip
                                size="small"
                                label={c.summary_name}
                                icon={<Icon icon={c?.summary_icon || ''} color='#fff' />}
                                sx={{
                                  mt: 0.5,
                                  bgcolor: c.summary_color,
                                  color: '#fff',
                                  fontWeight: 600,
                                  borderRadius: 1
                                }}
                              />
                            )}
                          </Box>
                        </Stack>
                      </Box>
                    )
                  })}

                  {filteredContact.length === 0 && (
                    <Box sx={{ py: 6, textAlign: 'center' }}>
                      <Typography color="text.secondary">
                        Kontak tidak ditemukan
                      </Typography>
                    </Box>
                  )}
                </Stack>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* RIGHT DETAIL */}
        <Grid item xs={12} md={7}>
          <Card sx={{ borderRadius: 3, height: '100%' }}>
            <CardContent sx={{ height: '100%' }}>
              {/* HEADER */}
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography fontWeight={700}>Contact Details</Typography>

                <IconButton onClick={handleMenuOpen} disabled={!selectedContact}>
                  <MoreVertIcon />
                </IconButton>

                <Menu
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleMenuClose}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                  {CHAT_ACTIONS.map(a => (
                    <MenuItem key={a.label} onClick={() => handleClickAction(a)}>
                      <ListItemIcon>
                        <Icon icon={a.icon} />
                      </ListItemIcon>
                      <ListItemText primary={a.label} />
                    </MenuItem>
                  ))}
                </Menu>
              </Stack>

              <Divider sx={{ my: 2 }} />

              {!selectedContact && (
                <Stack
                  alignItems="center"
                  justifyContent="center"
                  spacing={2}
                  sx={{ height: '70%' }}
                >
                  <Avatar sx={{ width: 72, height: 72, bgcolor: 'grey.200' }}>
                    <Icon icon="mdi:account-outline" fontSize={36} />
                  </Avatar>
                  <Typography color="text.secondary">
                    Pilih kontak untuk melihat detail
                  </Typography>
                </Stack>
              )}

              {selectedContact && (
                <>
                  {/* PROFILE */}
                  <Stack direction="row" spacing={3} alignItems="center">
                    <Avatar
                      sx={{
                        width: 88,
                        height: 88,
                        bgcolor: 'primary.main',
                        fontSize: 36,
                        fontWeight: 700
                      }}
                    >
                      {selectedContact?.contact_name?.[0]?.toUpperCase()}
                    </Avatar>

                    <Box>
                      <Typography variant="h6" fontWeight={700}>
                        {selectedContact?.contact_name}
                      </Typography>
                      {selectedContact?.summary?.name && (
                        <Chip
                          size="small"
                          label={selectedContact?.summary?.name}
                          icon={<Icon icon={selectedContact?.summary?.icon || ''} color='#fff' />}
                          sx={{
                            mt: 0.5,
                            bgcolor: selectedContact?.summary?.color,
                            color: '#fff',
                            fontWeight: 600,
                            borderRadius: 1
                          }}
                        />
                      )}
                    </Box>
                  </Stack>

                  <Divider sx={{ my: 3 }} />

                  {/* INFO GRID */}
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="caption" color="text.secondary">
                        Phone
                      </Typography>
                      <Typography fontWeight={600}>
                        {selectedContact.phone || '-'}
                      </Typography>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Typography variant="caption" color="text.secondary">
                        Tags
                      </Typography>
                      <Box mt={0.5}>
                        {selectedContact.tags.length ? (
                          selectedContact.tags.map((el: any) => (
                            <Chip
                              key={el.id}
                              size="small"
                              icon={
                                el.icon && (
                                  <Icon icon={el.icon} style={{ color: '#fff' }} />
                                )
                              }
                              label={el.name}
                              sx={{
                                bgcolor: el.hex_color,
                                color: '#fff',
                                fontWeight: 600,
                                borderRadius: 1,
                                mr: 1,
                                mb: 1
                              }}
                            />
                          ))
                        ) : (
                          <Typography fontWeight={600}>-</Typography>
                        )}
                      </Box>
                    </Grid>

                    <Grid item xs={12}>
                      <Typography variant="caption" color="text.secondary">
                        Alamat
                      </Typography>
                      <Typography>
                        {selectedContact?.alamat || '-'}
                      </Typography>
                    </Grid>
                  </Grid>
                </>
              )}
            </CardContent>
          </Card>
        </Grid>

      </Grid>


      {/* TAG */}
      <DialogTag
        open={activeDialog === 'tag'}
        contact={selectedContact}
        onClose={closeDialog}
        onReload={() => getChatByContact(selectedContact?.sdcust_id)}
      />

      {/* RINGKASAN */}
      <DialogRingkasan
        open={activeDialog === 'summary'}
        contact={selectedContact}
        onClose={closeDialog}
        onReload={() => {
          getContact()
          getChatByContact(selectedContact?.sdcust_id)
        }}
      />

      {/* ORDER */}
      <DialogOrder
        open={activeDialog === 'order'}
        contact={selectedContact}
        onClose={closeDialog}
      />

      {/* CATATAN */}
      <DialogCatatan
        open={activeDialog === 'note'}
        contact={selectedContact}
        onClose={closeDialog}
      />

      {/* JADWAL AKTIVITAS */}
      <DialogActivity
        open={activeDialog === 'schedule'}
        contact={selectedContact}
        onClose={closeDialog}
      />

    </Box>
  )
}
